import { render, staticRenderFns } from "./MarketplaceLicenseList.vue?vue&type=template&id=39a2bd4a&scoped=true"
import script from "./MarketplaceLicenseList.vue?vue&type=script&lang=js"
export * from "./MarketplaceLicenseList.vue?vue&type=script&lang=js"
import style0 from "./MarketplaceLicenseList.vue?vue&type=style&index=0&id=39a2bd4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39a2bd4a",
  null
  
)

export default component.exports